// src/components/Hero.jsx (Inline CSS for Centering/Responsiveness)

import React from 'react';

const Hero = ({ companyData }) => {
    const { owner, company, social, phone } = companyData;
    const whatsappUrl = `https://wa.me/${phone.replace(/\D/g, '')}`;

    const mainMoto = "Building Digital Experiences That Drive Growth.";
    const secondaryLine = "Custom Websites, Robust APIs, and Full-Stack Solutions for Modern Businesses.";
    
    return (
        <div 
            className="hero-content" 
            // 💡 Inline CSS for Centering and Responsiveness
            style={{
                // General layout settings
                maxWidth: '900px', // Limits max width on large screens
                margin: '0 auto', // Centers the block horizontally
                width: '100%', // Makes it responsive by always filling its parent width
                padding: '0 15px', // Adds horizontal padding for smaller screens
                
                // Text alignment
                textAlign: 'justify', // Centers all inline content (text, buttons, icons)
                
                // Ensures all elements are vertically aligned (less relevant here, but good practice)
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', // Centers children horizontally within the column
                justifyContent: 'center'
            }}
        >
            
            {/* Main Motto (H1) */}
            <h1 className="hero-moto" style={{ fontSize: '1.4em', marginBottom: '20px' }}>{mainMoto}</h1> 
            
            {/* Secondary Title/Description */}
            <p className="hero-title" style={{ fontSize: '0.9em', marginBottom: '30px' }}>{secondaryLine}</p>
            
            {/* Company/Owner Tagline */}
            <p className="hero-tagline" style={{ fontSize: '0.9em', marginBottom: '40px' }}>{company} - Innovative Digital Solutions by {owner}.</p>
            
            {/* Placeholder for visual element */}
            <div className="hero-image" style={{ marginBottom: '30px' }}>
                {/* Image integration would go here */}
            </div>
            
            {/* Call-to-Action Buttons */}
            <div 
                className="cta-buttons" 
                style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '5px', 
                    marginBottom: '50px' 
                    // NOTE: Full responsive stacking for buttons requires external CSS Media Queries.
                }}
            >
                <a href="#contact" className="btn btn-primary">Start Your Project</a>
                <a href="#projects" className="btn btn-secondary">Explore Our Work</a>
                <a 
                    href="https://drive.google.com/file/d/1Uk0M4opM4ofmGM9mQNx6DvMw-rhhIn7S/view?usp=sharing" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn btn-tertiary"
                >
                    View Resume
                </a>
            </div>

            {/* Social Media Icons (Requires Font Awesome) */}
            <div 
                className="hero-social-links" 
                style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '25px', 
                    marginTop: '20px' 
                }}
            >
                <a href={social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
                <a href={social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub"><i className="fab fa-github"></i></a>
                <a href={social.instagram || "#"} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href={social.facebook || "#"} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
        </div>
    );
};

export default Hero;